
  <h2 mat-dialog-title>{{title}}</h2>

  <mat-dialog-content>

    <div class="details" style="min-width:500px; padding-bottom:10px;">

 
      <div class="row">
          <div class="col-sm-3">LiturgicalYear: </div>
          <div class="col-sm-9">{{data.LiturgicalYear}}</div>
      </div>
      <div class="row">
          <div class="col-sm-3">LectionaryYear: </div>
          <div class="col-sm-9">{{data.LectionaryYear}}{{data.DailyOfficeLectionaryYear}}</div>
      </div> 
      <div class="row" *ngIf="data.JulianDateBritishObserved != null">
          <div class="col-sm-3">JulianDateBritishObserved: </div>
          <div class="col-sm-9">

                <div>{{data.JulianDateBritishObserved}}</div>

                <div style="margin-top:10px; font-size:12px">
                    On this day in Britain and its colonies, this old style Julian date was used while the rest of the world used the new style 
                    Gregorian date shown above. See <a href="https://en.wikipedia.org/wiki/Calendar_(New_Style)_Act_1750" target="_blank">https://en.wikipedia.org/wiki/Calendar_(New_Style)_Act_1750</a> for more information.
                </div>

            </div>
      </div>

  </div>

  <div class="text-right" style="margin-bottom:20px;">
    <button mat-button [mat-dialog-close]="true" class="btn">Close</button>
  </div>

  </mat-dialog-content>
